import { createModel } from "hox"
import { useCreation, useMemoizedFn, useSetState } from "ahooks"
import { useConfigModel } from "@/models"
import { gridTagConf, CHATGPT_KEY } from "@/constants/constant"
import { deepClone } from "@/util/util"

type StateProps = {
  tags: any[]
  gridTagMapConf: any | null
  gridTagList: any[]
}

function GridModal() {
  const { gptAuth } = useConfigModel()
  const [state, set] = useSetState<StateProps>({
    tags: [],
    gridTagMapConf: {},
    gridTagList: [],
  })

  const updateTags = useMemoizedFn((l: any[]) => {
    set({ tags: l })
  })

  useCreation(() => {
    const gridTagList = deepClone(gridTagConf)
    const map: any = {}
    //默认显示全部
    const list: any = []

    gridTagList.forEach((el: any) => {
      const parentKey = el.key
      const children = el.children
      // map[el.key] = {}
      if (children && children.length) {
        for (let i = 0; i < children.length; i++) {
          const item = children[i]
          const tagId = item.tagId
          // 判断是否显示chatgpt项
          if (tagId !== CHATGPT_KEY || gptAuth) {
            // map[el.key][tagId] = item
            item.parentKey = parentKey
            map[tagId] = item
            list.push(tagId)
          }
          if (tagId === CHATGPT_KEY && !gptAuth) {
            children.splice(i, 1)
            i--
          }
        }
      }
    })

    set({
      tags: list,
      gridTagMapConf: map,
      gridTagList,
    })
  }, [gptAuth])

  return {
    ...state,
    updateTags,
  }
}

export default createModel(GridModal)
